<bizz-modal modalSize="lg" title="TrackChanges" [contentTemplate]="contentTemplateRef"></bizz-modal>

<ng-template #contentTemplateRef>
    <div class="modal-content overflow-auto">
        <bizz-track-changes-grid [data]="data"></bizz-track-changes-grid>
    </div>
</ng-template>